<template>
  <footer class="footer" id="footer">
    <!-- footer content -->
  </footer>
</template>
